import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";
import { Form, Formik, useFormikContext } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";

import { Flex, Button, Box } from "@chakra-ui/react";

import Promotoria from "./Promotoria";
import Caracterizacao from "./Caracterizacao";
import Identificacao from "./Identificacao";
import InformacoesContato from "./InformacoesContato";

import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import turnToPascalCase from "../../../utils/turnToPascal";
import SemRegistros from "../../../components/SemRegistros";

import { API } from "../../../../main/config";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { hasFormChanged } from "../../../utils/hasFormChanged";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { isValidCNPJ } from "../../../utils/isValidCNPJ";
import { mascaraCNPJ } from "../../../utils/masks";

const ServicoAcolhimentoEditar = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();

  const { setEditarServicoServ } = useAppContext();
  const [existCNPJ, setExistCNPJ] = useState(false);
  const [invalidCNPJ, setInvalidCNPJ] = useState(false);
  const [message, setMessage] = useState("");
  const [dataSA, setDataSA] = useState();
  const suportedImageFormats = [
    "image/jpg",
    "image/jpeg",
    "image/tiff",
    "image/png",
    "image/bmp",
  ];

  const [modalidades, setModalidades] = useState({
    options: [],
    isLoading: false,
  });
  const [defaultImage, setDefaultImage] = useState("");
  const [defaultLogo, setDefaultLogo] = useState();
  const [defaultEstado, setDefaultEstado] = useState();
  const [defaultMunicipio, setDefaultMunicipio] = useState();
  const [initialValues, setInitialValues] = useState({
    promotoriaId: "",
    varaInfanciaId: "",
    numeroInclusao: "",
    procedimentoDesativacao: "",
    naturezaServico: "",
    regime: "",
    modalidade: "",
    logomarca: null,
    nomeFantasia: "",
    razaoSocial: "",
    cnpj: "",
    site: "",
    estadoId: "",
    municipioId: "",
    bairroId: "",
    logradouro: "",
    numeroResidencia: "",
    cep: "",
    complemento: "",
    pontoReferencia: "",
    mantenedoras: [
      {
        id: 0,
        nome: "",
      },
    ],
    telefones: [
      {
        telefone: "",
        descricao: "",
      },
    ],
    emails: [
      {
        email: "",
        descricao: "",
      },
    ],
  });

  function formatarCEP(cep) {
    if (cep.length === 8) {
      const parte1 = cep.slice(0, 5);
      const parte2 = cep.slice(5);
      return `${parte1}-${parte2}`;
    }
    return cep;
  }
  useEffect(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
        const {
          id,
          promotoria,
          varaInfancia,
          mantenedora,
          mantenedoras,
          telefones,
          emails,
          logomarca,
          endereco,
          tipoServicoAcolhimento,
          numeroInclusao,
          procedimentoDesativacao,
          razaoSocial,
          cnpj,
          site,
          complemento,
          pontoReferencia,
          unidadeMp,
          link,
          dataSuspensao,
          desativado,
          justificativaReativacao,
          justificativaSuspensao,
          observacoesDesativacao,
          observacoesReativacao,
          suspenso,
          ...resto
        } = res.data;

        setDefaultLogo(logomarca);
        setDefaultImage(API + `/servico-acolhimento/logo/${id}`);
        setDefaultEstado(endereco.estado);
        setDefaultMunicipio(endereco.municipio);

        setInitialValues({
          ...resto,
          numeroInclusao: numeroInclusao ? numeroInclusao : "",
          procedimentoDesativacao: procedimentoDesativacao
            ? procedimentoDesativacao
            : "",
          razaoSocial: razaoSocial ? razaoSocial : "",
          cnpj: cnpj ? mascaraCNPJ(cnpj) : "",
          site: site ? site : "",
          promotoriaId: promotoria,
          varaInfanciaId: varaInfancia,
          modalidade: {
            label: tipoServicoAcolhimento.modalidade,
            value: tipoServicoAcolhimento.modalidade,
          },
          regime: {
            label:
              tipoServicoAcolhimento.regime === "SAI"
                ? "Serviço de Acolhimento Institucional"
                : "Serviço de Acolhimento Familiar",
            value: tipoServicoAcolhimento.regime,
          },
          mantenedoras:
            mantenedoras?.length > 0
              ? mantenedoras
              : [
                  {
                    id: 0,
                    nome: "Não informado",
                  },
                ],
          logomarca: null,
          telefones: telefones
            ? telefones.length > 0
              ? telefones
              : [
                  {
                    id: 0,
                    telefone: "",
                    descricao: "",
                  },
                ]
            : [
                {
                  id: 0,
                  telefone: "",
                  descricao: "",
                },
              ],
          emails: emails
            ? emails.length > 0
              ? emails
              : [
                  {
                    email: "",
                    descricao: "",
                  },
                ]
            : [
                {
                  email: "",
                  descricao: "",
                },
              ],
          estadoId: endereco.estado,
          municipioId: endereco.municipio,
          bairroId: endereco.bairro ? endereco.bairro : "",
          logradouro: endereco.logradouro,
          numeroResidencia: endereco.numeroResidencia,
          cep: formatarCEP(endereco.cep),
          complemento: endereco.complemento ? endereco.complemento : "",
          pontoReferencia: endereco.pontoReferencia
            ? endereco.pontoReferencia
            : "",
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push("/servico-acolhimento");
        });
      });
  }, [history, id]);

  const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
      if (isSubmitting && !isValidating) {
        let keys = Object.keys(errors);
        if (keys.length > 0) {
          const selector = `[name=${keys[0]}]`;
          const errorElement = document.querySelector(selector);
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            errorElement.focus({ preventScroll: true });
          }
        }
      }
    }, [errors, isSubmitting, isValidating]);

    return null;
  };

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { cnpj } = values;

        if (cnpj) {
          if (isValidCNPJ(cnpj)) {
            setInvalidCNPJ(true);
            setFieldError("cnpj", "");

            ServicoAcolhimentoService.postValidCNPJ(cnpj, id)
              .then((res) => {
                if (res?.data === true) {
                  setMessage("CNPJ já existente em um Serviço de Acolhimento.");
                  setExistCNPJ(true);
                } else {
                  setMessage("");
                  setExistCNPJ(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setMessage("");
                setExistCNPJ(false);
              });
          } else {
            setFieldError("cnpj", "");
            setInvalidCNPJ(false);
          }
        } else {
          setMessage("");
          setInvalidCNPJ(false);
          setExistCNPJ(false);
        }
      };

      validateDate();
    }, [values, values.dataMovimentacao, setFieldError]);

    return null;
  };

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  const schema = Yup.object().shape({
    promotoriaId: Yup.object().required("Este campo é obrigatório!"),
    varaInfanciaId: Yup.object().required("Este campo é obrigatório!"),
    naturezaServico: Yup.string().required("Este campo é obrigatório!"),
    regime: Yup.object().required("Este campo é obrigatório!"),
    logomarca: Yup.mixed()
      .test("imageSize", "O arquivo tem mais de 2MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 2000000;
        }
      })
      .test("imageType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          return suportedImageFormats.includes(value.type);
        }
      }),
    nomeFantasia: Yup.string()
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    site: Yup.string(),
    estadoId: Yup.object().required("Este campo é obrigatório!"),
    municipioId: Yup.object().required("Este campo é obrigatório!"),
    logradouro: Yup.string()
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    cep: Yup.string()
      .required("Este campo é obrigatório!")
      .min(9, "Cep inválido!"),
    cnpj: Yup.string()
      .test("cpfValido", "", (value) => {
        if (
          !isValidCNPJ(value) &&
          roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizarTudo)
        ) {
          return false;
        } else {
          return true;
        }
      })
      .test("unicidadeCNPJ", "", (value) => {
        if (existCNPJ) {
          return false;
        } else {
          return true;
        }
      }),
    telefones: Yup.array().of(
      Yup.object().shape({
        telefone: Yup.string()
          .min(14, "Telefone inválido!")
          .max(15, "Telefone inválido!"),
        descricao: Yup.string()
          .trim()
          .when("telefone", {
            is: (tel) => {
              return tel === undefined || tel === "";
            },
            then: Yup.string().test(
              "filledWithouTel",
              "Descrição sem telefone!",
              (value) => {
                return value === undefined || value === "";
              }
            ),
          }),
      })
    ),
    emails: Yup.array().of(
      Yup.object().shape({
        email: Yup.string().trim().email("Email inválido!"),
        descricao: Yup.string()
          .trim()
          .when("email", {
            is: (email) => {
              return email === undefined || email === "";
            },
            then: Yup.string().test(
              "filledWithouEmail",
              "Descrição sem email!",
              (value) => {
                return value === undefined || value === "";
              }
            ),
          }),
      })
    ),
    mantenedoras: Yup.array().of(
      Yup.object().shape({
        nome: Yup.string()
          .nullable()
          .trim("Este campo é obrigatório!")
          .test(
            "hasOneValid",
            "Este campo é obrigatório!",
            (value, context) => value
          ),
      })
    ),
  });
  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        mantenedoras,
        telefones,
        emails,
        modalidade,
        numeroResidencia,
        logomarca,
        estadoId,
        municipioId,
        bairroId,
        promotoriaId,
        complemento,
        pontoReferencia,
        varaInfanciaId,
        nomeFantasia,
        logradouro,
        regime,
        dataDesativacao,
        ...resto
      } = values;
      const valuesToSend = {
        ...resto,
        telefones: JSON.stringify(
          telefones
            .filter((obj) => obj.telefone.trim() !== "")
            .map((obj) => {
              if (obj.descricao.trim() !== "") {
                return {
                  ...obj,
                  id: obj.id ? obj.id : 0,
                  descricao: turnToPascalCase(obj.descricao.trim()),
                };
              } else {
                return {
                  ...obj,
                  id: obj.id ? obj.id : 0,
                  descricao: obj.descricao.trim(),
                };
              }
            })
        ),
        emails: JSON.stringify(
          emails
            .filter((obj) => obj.email.trim() !== "")
            .map((obj) => {
              if (obj.descricao.trim() !== "") {
                return {
                  ...obj,
                  id: obj.id ? obj.id : 0,
                  descricao: turnToPascalCase(obj.descricao.trim()),
                };
              } else {
                return {
                  ...obj,
                  id: obj.id ? obj.id : 0,
                  descricao: obj.descricao.trim(),
                };
              }
            })
        ),
        mantenedora: JSON.stringify(mantenedoras),
        mantenedoras: JSON.stringify(mantenedoras),
        regime: regime.value,
        modalidade: modalidade.value,
        numeroResidencia:
          Number(numeroResidencia) !== 0 ? Number(numeroResidencia) : "",
        logomarca: logomarca,
        estadoId: estadoId.id,
        municipioId: municipioId ? municipioId.id : "",
        bairroId: bairroId ? bairroId.id : "",
        promotoriaId: promotoriaId.id,
        varaInfanciaId: varaInfanciaId.id,
        nomeFantasia: nomeFantasia.trim(),
        logradouro: logradouro.trim(),
        imagemRemovida: defaultLogo ? defaultImage === "" : false,
        complemento: complemento ? complemento : "",
        pontoReferencia: pontoReferencia ? pontoReferencia : "",
        unidadeMpId: 1,
      };

      ServicoAcolhimentoService.editarServicoAcolhimento(id, valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro atualizado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.push("/servico-acolhimento/" + res.data.id);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              } else {
                actions.setFieldError(
                  error.response.data.field,
                  error.response.data.message
                );
              }
            }
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(servicoAcolhimentoFunc.editar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
      <Flex flexDir="column" w="100%">
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => (
            <Form onKeyDown={onKeyDown}>
              {setEditarServicoServ(
                hasFormChanged(initialValues, props.values)
              )}
              <FocusError />
              <FocusErrorData />
              {roleKeycloack &&
                roleKeycloack.includes(criancaFunc.visualizarTudo) && (
                  <>
                    <Promotoria formProps={props} />
                    <Caracterizacao
                      formProps={props}
                      modalidades={modalidades}
                      setModalidades={setModalidades}
                    />
                    <Identificacao
                      formProps={props}
                      defaultImage={defaultImage}
                      setDefaultImage={setDefaultImage}
                      defaultEstado={defaultEstado}
                      defaultMunicipio={defaultMunicipio}
                      invalidCNPJ={invalidCNPJ}
                      existCNPJ={existCNPJ}
                      message={message}
                    />
                  </>
                )}

              <InformacoesContato formProps={props} />
              <Flex justifyContent="flex-end">
                <Button
                  type="submit"
                  translate="no"
                  mt="30px"
                  px="45px"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  isLoading={props.isSubmitting}
                >
                  Salvar
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Flex>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default ServicoAcolhimentoEditar;
